if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        // Verifica se l'input variantId esiste prima di accedervi
        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        // Rimuoviamo l'assegnazione qui perché l'attributo viene aggiunto dinamicamente
        // this.upsellVariantId = this.dataset.upsellVariantId;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        console.log('this.form.checkValidity()', this.form.checkValidity());
        if (!this.form.checkValidity()) {
          this.form.reportValidity(); // funziona anche con novalidate = NO
          return;
        }
        setTimeout(async () => {
          const otherProdInputs = this.scanForm();
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      
          this.handleErrorMessage();
      
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');
      
          try {
            // Ottieni lo stato corrente del carrello
            const cartState = await this.getCartState();
            const configs = this.getProdConfig(otherProdInputs);
            // console.log(configs);

            for (const conf of configs) {
              if (conf.requestType === 'upsell') {
                // console.log('config upsell: ', conf);

                await this.addLinUpsellProduct(conf);
              } else {
                // console.log('config NOT upsell: ', conf);

                await this.addLinPageProduct(conf);
              }
            }
            
          } catch (error) {
            console.error('Errore durante l\'aggiunta al carrello:', error);
            this.handleErrorMessage('Si è verificato un errore durante l\'aggiunta al carrello.');
          } finally {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
            this.querySelector('.loading__spinner').classList.add('hidden');
          }
        }, 100);
      }


      scanForm() {
        const intruses = this.querySelectorAll('input[type="hidden"][class]:not(.product-variant-id)') || null;
        return intruses;        
      }

      async getCartState() {
        const response = await fetch(`${routes.cart_url}.js`);
        return await response.json();
      }

      async addUpsellProduct(upsellVariantId) {
        try {
          const config = this.getUpsellProductConfig(upsellVariantId);
          const response = await fetch(`${routes.cart_add_url}`, config);
          const result = await response.json();
          
          if (result.status) {
            console.warn('Errore aggiunta prodotto upsell:', result.description);
          } else {
            // console.log('Prodotto upsell aggiunto con successo');
          }
          
          return result;
        } catch (error) {
          console.error('Errore durante l\'aggiunta del prodotto upsell:', error);
          throw error;
        }
      }


      getProdConfig(eventInputToExclude) {
        const configs = [];
        const excludedInputs = eventInputToExclude ? [...eventInputToExclude] : [];
        console.log(eventInputToExclude, excludedInputs);
        

        if (excludedInputs.length > 0) {
          const groupedInputs = Object.values(
            excludedInputs.reduce((acc, input) => {
              const key = input.dataset.groupedVarId;
              if (!key) return acc;

              acc[key] ??= {
                group: key,
                inputs: []
              };

              acc[key].inputs.push(input);
              return acc;
            }, {})
          );

          // console.log('groupedInputs:', groupedInputs);
          groupedInputs.forEach(group => {
            const varInput = group.inputs.find(
              inp => inp.name === 'items[][id]'
            );

            if (!varInput) return;

            const upsellFormData = new FormData();
            upsellFormData.append('id', varInput.value);
            upsellFormData.append('quantity', 1);

            const upsellConfig = fetchConfig('javascript');

            upsellConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete upsellConfig.headers['Content-Type'];

            upsellConfig.body = upsellFormData;
            upsellConfig.requestType = 'upsell';

            configs.push(upsellConfig);
          });
        }

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (excludedInputs.length > 0) {

          for (const input of excludedInputs) {
            if (input.name) {
              formData.delete(input.name);
            }
          }
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map(section => section.id)
          );
          formData.append(
            'sections_url',
            window.location.pathname
          );

          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;
        config.requestType = 'main';
        configs.push(config);
        // console.log('configs final:', configs);
        return configs;
      }

      // getProdConfig(eventInputToExclude) {
      //   const configs = [];
      //   const excludedInputs = eventInputToExclude ? [...eventInputToExclude] : [];
 
      //   if (excludedInputs.length > 0) {
 
      //     // --- 1) Upsell "classici", raggruppati tramite data-grouped-var-id ---
      //     // Escludiamo esplicitamente gli input omaggio da questo raggruppamento:
      //     // hanno una logica di pairing diversa (vedi punto 2) e non possiedono
      //     // comunque data-grouped-var-id.
      //     const groupedByDataAttr = excludedInputs.filter(
      //       (input) => input.dataset.groupedVarId && !input.classList.contains('nwt-free-gift-input')
      //     );
 
      //     const groupedInputs = Object.values(
      //       groupedByDataAttr.reduce((acc, input) => {
      //         const key = input.dataset.groupedVarId;
      //         acc[key] ??= {
      //           group: key,
      //           inputs: []
      //         };
 
      //         acc[key].inputs.push(input);
      //         return acc;
      //       }, {})
      //     );
 
      //     // console.log('groupedInputs:', groupedInputs);
      //     groupedInputs.forEach(group => {
      //       const varInput = group.inputs.find(
      //         inp => inp.name === 'items[][id]'
      //       );
 
      //       if (!varInput) return;
 
      //       const upsellFormData = new FormData();
      //       upsellFormData.append('id', varInput.value);
      //       upsellFormData.append('quantity', 1);
 
      //       const upsellConfig = fetchConfig('javascript');
 
      //       upsellConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
      //       delete upsellConfig.headers['Content-Type'];
 
      //       upsellConfig.body = upsellFormData;
      //       upsellConfig.requestType = 'upsell';
 
      //       configs.push(upsellConfig);
      //     });
 
      //     // --- 2) Prodotti omaggio (free gift), riconosciuti tramite classe
      //     // .nwt-free-gift-input iniettata dal blocco liquid. Vengono trattati
      //     // come "upsell" ai fini del config: ognuno genera una /cart/add.js
      //     // separata invece di confluire nella richiesta items[][] del prodotto
      //     // principale (evita batch multi-item che mandano in crash il pixel
      //     // e/o moltiplicano/azzerano l'evento product_added_to_cart).
      //     const giftInputs = excludedInputs.filter((input) =>
      //       input.classList.contains('nwt-free-gift-input')
      //     );
 
      //     // Il blocco liquid inserisce le coppie in ordine: id, quantity, id, quantity, ...
      //     // Filtrando per name si mantiene l'ordine relativo originale, quindi
      //     // l'n-esimo id corrisponde sempre all'n-esima quantity.
      //     const giftIdInputs = giftInputs.filter((input) => input.name === 'items[][id]');
      //     const giftQtyInputs = giftInputs.filter((input) => input.name === 'items[][quantity]');
 
      //     giftIdInputs.forEach((idInput, index) => {
      //       if (!idInput.value) return;
 
      //       const qtyInput = giftQtyInputs[index];
      //       const quantity = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) || 1 : 1;
 
      //       const giftFormData = new FormData();
      //       giftFormData.append('id', idInput.value);
      //       giftFormData.append('quantity', quantity);
 
      //       const giftConfig = fetchConfig('javascript');
 
      //       giftConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
      //       delete giftConfig.headers['Content-Type'];
 
      //       giftConfig.body = giftFormData;
      //       giftConfig.requestType = 'upsell';
      //       giftConfig.isFreeGift = true; // marcatore utile per debug/log, non usato dal flusso
 
      //       configs.push(giftConfig);
      //     });
      //   }
 
      //   const config = fetchConfig('javascript');
 
      //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
      //   delete config.headers['Content-Type'];
 
      //   const formData = new FormData(this.form);
 
      //   if (excludedInputs.length > 0) {
 
      //     for (const input of excludedInputs) {
      //       if (input.name) {
      //         formData.delete(input.name);
      //       }
      //     }
      //   }
 
      //   if (this.cart) {
      //     formData.append(
      //       'sections',
      //       this.cart.getSectionsToRender().map(section => section.id)
      //     );
      //     formData.append(
      //       'sections_url',
      //       window.location.pathname
      //     );
 
      //     this.cart.setActiveElement(document.activeElement);
      //   }
 
      //   config.body = formData;
      //   config.requestType = 'main';
      //   configs.push(config);
      //   // console.log('configs final:', configs);
      //   return configs;
      // }

      async addLinPageProduct(config) {
        try {
          const response = await fetch(`${routes.cart_add_url}`, config);
          const result = await response.json();

          
          
          if (result.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: this.getMainProductVariantId(),
              errors: result.errors || result.description,
              message: result.message,
            });
            
            this.handleErrorMessage(result.description);
            
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            this.error = true;
            return;
            
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // console.log('Prodotto principale aggiunto con successo');
          
          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: this.getMainProductVariantId(),
              cartData: result,
            });
          }
          
          this.error = false;
          
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(result);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(result);
          }
          
        } catch (error) {
          console.error('Errore durante l\'aggiunta del prodotto principale:', error);
          this.handleErrorMessage('Si è verificato un errore durante l\'aggiunta al carrello.');
          throw error;
        }
      }


      async addLinUpsellProduct(config) {
        try {
            console.log('addLinUpsellProduct');
          const response = await fetch(`${routes.cart_add_url}`, config);
          const result = await response.json();
          
          if (result.status) {
            console.warn('Errore aggiunta prodotto upsell:', result.description);
          } else {
            console.log('Prodotto upsell aggiunto con successo', result);
          }
          
          return result;
        } catch (error) {
          console.error('Errore durante l\'aggiunta del prodotto upsell:', error);
          throw error;
        }
      }

      async addMainProduct() {
        try {
          const config = this.getMainProductConfig();
          const response = await fetch(`${routes.cart_add_url}`, config);
          const result = await response.json();
          
          if (result.status) {
            // Gestione errori
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: this.getMainProductVariantId(),
              errors: result.errors || result.description,
              message: result.message,
            });
            
            this.handleErrorMessage(result.description);
            
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            this.error = true;
            return;
            
          } else if (!this.cart) {
            // Se non c'è cart drawer/notification, reindirizza al carrello
            window.location = window.routes.cart_url;
            return;
          }

          // Successo - aggiorna l'interfaccia del carrello
          // console.log('Prodotto principale aggiunto con successo');
          
          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: this.getMainProductVariantId(),
              cartData: result,
            });
          }
          
          this.error = false;
          
          // Gestisci modal quick-add se presente
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(result);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(result);
          }
          
        } catch (error) {
          console.error('Errore durante l\'aggiunta del prodotto principale:', error);
          this.handleErrorMessage('Si è verificato un errore durante l\'aggiunta al carrello.');
          throw error;
        }
      }




      getMainProductConfig() {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        // Rimuovi tutti gli input items[][] per evitare conflitti
        const keysToDelete = [];
        for (let [key, value] of formData.entries()) {
          if (key.startsWith('items[')) {
            keysToDelete.push(key);
          }
        }
        keysToDelete.forEach(key => formData.delete(key));
        
        // Aggiungi le sezioni per il rendering del carrello se necessario
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        // console.log(config, formData);
        
        return config;
      }

      getUpsellProductConfig(upsellVariantId) {
        const upsellFormData = new FormData();
        upsellFormData.append('id', upsellVariantId);
        upsellFormData.append('quantity', 1);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = upsellFormData;

        return config;
      }

      getUpsellVariantId() {
        // Ottieni l'ID dell'upsell dinamicamente ogni volta che viene chiamato
        // questo permette allo snippet liquid di aggiungere l'attributo prima del submit
        return this.dataset.upsellVariantId;
      }

      getMainProductVariantId() {
        const formData = new FormData(this.form);
        return formData.get('id');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // toggleSubmitButton(disable = true, text) {
      //   if (disable) {
      //     this.submitButton.setAttribute('disabled', 'disabled');

      //   } else {
      //     this.submitButton.removeAttribute('disabled'); 
      //   }
      // }


      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          
          if (text) {
            let outOfStock = this.submitButton.querySelector('.out-of-stock-text');
            let iconaTestoAtc = this.submitButton.querySelector('.icona_testo_atc');
            console.log('disable ',text,iconaTestoAtc);

            if (!outOfStock) {
              outOfStock = document.createElement('span');
              outOfStock.classList.add('out-of-stock-text');
              this.submitButton.querySelector('button span').appendChild(outOfStock);
            }

            outOfStock.innerText = text;

            if(iconaTestoAtc) iconaTestoAtc.style.display = "none";
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          let iconaTestoAtc = this.submitButton.querySelector('.icona_testo_atc');

          if(iconaTestoAtc && iconaTestoAtc.style.display == "none") {
            iconaTestoAtc.style.display = "";
          }

          const outOfStock = this.submitButton.querySelector('.out-of-stock-text');

          if (outOfStock) {
            outOfStock.remove();
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}